// util/dataExtractor.js

/**
 * Extracts a value from Google Maps Geocoding API response based on type
 * @param {object} response - The full JSON response from Google Maps
 * @param {string} type - The address component type to search for (e.g., 'locality', 'postal_code')
 * @returns {string} - The matched component's long_name or an empty string
 */
export const extractFromResponse = (response, type) => {
  const components = response?.results?.[0]?.address_components || [];
  const match = components.find(comp => comp.types.includes(type));
  return match?.long_name || '';
};


export const isUserEmailVerified = currentUser => {
  return currentUser?.attributes?.emailVerified;
};
